import { GET_COMPANY_TERM_EVALUATION_STATE } from '../../../constants/api'
import errorHandler from '../errorHandler'
import { ITermState } from '../../../common/models/Term'
import { setDatesToPurePdp } from '../pdp/loadPersonalPdp.service'

export default (termId: string, token: string) =>
  fetch(GET_COMPANY_TERM_EVALUATION_STATE(termId), {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then(errorHandler)
    .then(
      async (termStatesResponse: Response): Promise<ITermState> => {
        const termState: ITermState = await termStatesResponse.json()
        return {
          ...termState,
          memberStates: termState.memberStates.map((memberState) => ({
            ...memberState,
            pdp: memberState.pdp
              ? setDatesToPurePdp(memberState.pdp)
              : undefined,
          })),
        }
      }
    )
